import { css } from "@emotion/react";

export const dashboardClickableTileStyles = css`
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.08);
  transition:
    box-shadow 0.15s ease,
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    border-color: rgba(0, 0, 0, 0.14);
    background-color: rgba(0, 0, 0, 0.02);
  }

  &:active {
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 2px solid #1976d2;
    outline-offset: 2px;
  }
`;
